import { Loading } from '@components/loading';
import { useUser } from '@components/user';
import React from 'react';

const loadAuthenticatedApp = () =>
  import('./authenticated-app').then(module => ({
    default: module.AuthenticatedApp
  }));
const AuthenticatedApp = React.lazy(loadAuthenticatedApp);

const UnauthenticatedApp = React.lazy(() =>
  import('./unauthenticated-app').then(module => ({
    default: module.UnauthenticatedApp
  }))
);

export function App() {
  const { user } = useUser();
  // pre-load the authenticated side in the background while the user's
  // filling out the login form.
  React.useEffect(() => {
    loadAuthenticatedApp();
  }, []);
  return (
    <React.Suspense
      fallback={<Loading vertical="center" horizontal="center" padding={6} />}
    >
      {user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
    </React.Suspense>
  );
}
